export default __webpack_public_path__ + "static/media/youtube-icon.759fccff.svg";